<template>
  <TabView class="p-nogutter p-mb-4 md:p-mb-0">
    <TabPanel header="Parents">
      <ParentViewComponent :callFrom="'Activated'"/>
    </TabPanel>

    <TabPanel header="Approved Inactive">
      <ParentViewComponent :callFrom="'Inactive'"/>
    </TabPanel>

    <TabPanel header="For Approval">
      <ParentViewComponent :callFrom="'For Approval'"/>
    </TabPanel>


  </TabView>
</template>
<script>
import ParentViewComponent from '@/components/parents/ParentViewComponent.vue'
</script>
